import { TFunction } from '@spotify-internal/i18n-core/types';

export enum APPROVAL_REASON {
  RIGHTS_TO_RELEASE = 'RIGHTS_TO_RELEASE',
  RIGHTS_TO_ARTIST = 'RIGHTS_TO_ARTIST',
  NOT_SAME_ARTIST = 'NOT_SAME_ARTIST',
  SHOULD_NOT_GO_LIVE = 'SHOULD_NOT_GO_LIVE',
}

export const getReasonLabels = (t: TFunction) => ({
  [APPROVAL_REASON.RIGHTS_TO_RELEASE]: t(
    'catalog.on_held.request_modal.own_album_rights',
    'We own or have licensed the rights to this release.',
    'On held reason for approval "own rights to release"',
  ),
  [APPROVAL_REASON.RIGHTS_TO_ARTIST]: t(
    'catalog.on_held.request_modal.own_artist_rights',
    'We own or have licensed the rights to this artist.',
    'On held reason for approval "own artist rights"',
  ),
  [APPROVAL_REASON.NOT_SAME_ARTIST]: t(
    'catalog.on_held.request_modal.not_same_artist',
    "This artist isn't the same as the artist on the Watchlist.",
    'On held reason for approval "not the same artist"',
  ),
  [APPROVAL_REASON.SHOULD_NOT_GO_LIVE]: t(
    'catalog.on_held.request_modal.should_not_go_live',
    'The release should not go live.',
    'On held reason for approval "should not go live"',
  ),
});

export const getPopoverDescription = (t: TFunction) => ({
  [APPROVAL_REASON.RIGHTS_TO_RELEASE]: t(
    'atlas.held_releases.date_submitted_popover.description',
    "Your request has been submitted. Products can take up to 5 business days to go live. We'll remove your product from this list after we've verified the approval.",
    'Popover message to give context after submitting a request',
  ),
  [APPROVAL_REASON.RIGHTS_TO_ARTIST]: t(
    'atlas.held_releases.date_submitted_popover.description',
    "Your request has been submitted. Products can take up to 5 business days to go live. We'll remove your product from this list after we've verified the approval.",
    'Popover message to give context after submitting a request',
  ),
  [APPROVAL_REASON.NOT_SAME_ARTIST]: t(
    'atlas.held_releases.content_relocation_popover.description',
    "Your request has been submitted. Fill out the Content Relocation form if you haven't already. It can take up to 5 business days for the Metadata team to get in touch and for your product to go live. We'll remove your product from this list after we've verified the approval.",
    'Popover message to give context after submitting a content relocation request',
  ),
  [APPROVAL_REASON.SHOULD_NOT_GO_LIVE]: t(
    'atlas.held_releases.should_not_go_live_popover.description',
    'Your request has been submitted. No additional action is required once you have submitted a request. The release will not go live.',
    'Popover message to give context after submitting a should not go live request',
  ),
});
